export default __webpack_public_path__ + "static/media/programming-school.1d5dc1a8.webp";